export default {
  result: String,
  outline: Boolean,
  value: String,
  disabled: Boolean,
  label: String,
  state: {
    default: 'primary'
  },
  size: String,
  light: Boolean
}


// WEBPACK FOOTER //
// ./src/components/Radio/_props.js